import React from 'react'
import Error from '../EqxError'
import Loading from '../EqxLoading'
import './EqxRequestHandler.css'

export default (props: {
    state: { loading: boolean; error: string | null; hasContent?: boolean } //hasContent: even if it's loading, show content
    isEmpty?: boolean
    empty?: React.ReactNode
    error?: React.ReactNode
    loading?: React.ReactNode
    content?: () => React.ReactNode // using children doesn't work unless content is refactored to its own component, this is a way around
    children?: React.ReactNode
}): JSX.Element => {
    const state = props.state

    if (state.loading && !state.hasContent) {
        return <>{props.loading ?? <Loading />}</>
    }
    if (state.error) {
        return (
            <>{props.error ?? <Error error={typeof state.error == 'string' ? state.error : 'Could not load data'} icon="fas fa-exclamation-circle" />}</>
        )
    }
    if (props.isEmpty) {
        return <>{props.empty ?? <div className="p-5 text-center text-muted">None</div>}</>
    }

    const content = props.content ? props.content() : props.children
    return (
        <>
            {state.loading && state.hasContent /* show loading and content */ ? (
                <div className="loading-cover-container">
                    {content}
                    <div className="loading-cover">
                        <Loading />
                    </div>
                </div>
            ) : (
                <>{content}</>
            )}
        </>
    )
}
